export default __webpack_public_path__ + "static/media/closet5-before3-2048w.94d1299c.avif";